/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListChainReportsQueryResponse,
  ListChainReportsQueryParams,
} from '../types/ListChainReports'

function getListChainReportsUrl() {
  const res = { method: 'GET', url: `/api/v1/reports/chains/` as const }
  return res
}

/**
 * @description Paginated list of chain reports (chains joined with CRM data). Raw-SQL view backed by ChainsWithCRMReportsRequestParams (a Pydantic model, not a DjangoFilterBackend filterset), so every query param is listed explicitly below -- drf-spectacular cannot auto-introspect it.
 * @summary List chain reports
 * {@link /api/v1/reports/chains/}
 */
export async function listChainReports(
  params?: ListChainReportsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListChainReportsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListChainReportsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
